import { apiClient } from './api';

// Get full discover phase data for a project
export const getDiscoverPhaseData = async (projectId) => {
  try {
    const response = await apiClient.get(`/projects/${projectId}/discovery-phase`);
    return response.data;
  } catch (error) {
    console.error('Error fetching discover phase data:', error);
    throw error;
  }
};

// Business Assessment
export const getBusinessAssessment = async (projectId) => {
  try {
    const response = await apiClient.get(`/projects/${projectId}/discovery-phase/business-assessment`);
    if (response.data && !response.data.message) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching business assessment:', error);
    return null;
  }
};

export const saveBusinessAssessment = async (projectId, assessmentData) => {
  try {
    const response = await apiClient.post(`/projects/${projectId}/discovery-phase/business-assessment`, assessmentData);
    return response.data;
  } catch (error) {
    console.error('Error saving business assessment:', error);
    throw error;
  }
};

export const fetchBusinessAssessmentFromSOW = async (projectId) => {
  try {
    const response = await apiClient.post(`/projects/${projectId}/discovery-phase/business-assessment/fetch-from-sow`);
    return response.data;
  } catch (error) {
    console.error('Error fetching business assessment from SOW:', error);
    throw error;
  }
};

// Current Landscape Analysis
export const getCurrentLandscapeAnalysis = async (projectId) => {
  try {
    const response = await apiClient.get(`/projects/${projectId}/discovery-phase/current-landscape-analysis`);
    if (response.data && !response.data.message) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching current landscape analysis:', error);
    return null;
  }
};

export const saveCurrentLandscapeAnalysis = async (projectId, analysisData) => {
  try {
    const response = await apiClient.post(`/projects/${projectId}/discovery-phase/current-landscape-analysis`, analysisData);
    return response.data;
  } catch (error) {
    console.error('Error saving current landscape analysis:', error);
    throw error;
  }
};

export const fetchCurrentLandscapeAnalysisFromSOW = async (projectId) => {
  try {
    const response = await apiClient.post(`/projects/${projectId}/discovery-phase/current-landscape-analysis/fetch-from-sow`);
    return response.data;
  } catch (error) {
    console.error('Error fetching current landscape analysis from SOW:', error);
    throw error;
  }
};

// Requirements Gathering
export const getRequirementsGathering = async (projectId) => {
  try {
    const response = await apiClient.get(`/projects/${projectId}/discovery-phase/requirements-gathering`);
    if (response.data && !response.data.message) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching requirements gathering:', error);
    return null;
  }
};

export const saveRequirementsGathering = async (projectId, requirementsData) => {
  try {
    const response = await apiClient.post(`/projects/${projectId}/discovery-phase/requirements-gathering`, requirementsData);
    return response.data;
  } catch (error) {
    console.error('Error saving requirements gathering:', error);
    throw error;
  }
};

export const fetchRequirementsGatheringFromSOW = async (projectId) => {
  try {
    const response = await apiClient.post(`/projects/${projectId}/discovery-phase/requirements-gathering/fetch-from-sow`);
    return response.data;
  } catch (error) {
    console.error('Error fetching requirements gathering from SOW:', error);
    throw error;
  }
};

// Stakeholder Interviews
export const getStakeholderInterviews = async (projectId) => {
  try {
    const response = await apiClient.get(`/projects/${projectId}/discovery-phase/stakeholder-interviews`);
    if (response.data && !response.data.message) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching stakeholder interviews:', error);
    return null;
  }
};

export const saveStakeholderInterviews = async (projectId, interviewsData) => {
  try {
    const response = await apiClient.post(`/projects/${projectId}/discovery-phase/stakeholder-interviews`, interviewsData);
    return response.data;
  } catch (error) {
    console.error('Error saving stakeholder interviews:', error);
    throw error;
  }
};

export const fetchStakeholderInterviewsFromSOW = async (projectId) => {
  try {
    const response = await apiClient.post(`/projects/${projectId}/discovery-phase/stakeholder-interviews/fetch-from-sow`);
    return response.data;
  } catch (error) {
    console.error('Error fetching stakeholder interviews from SOW:', error);
    throw error;
  }
};

// Technology Assessment
export const getTechnologyAssessment = async (projectId) => {
  try {
    const response = await apiClient.get(`/projects/${projectId}/discovery-phase/technology-assessment`);
    if (response.data && !response.data.message) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching technology assessment:', error);
    return null;
  }
};

export const saveTechnologyAssessment = async (projectId, assessmentData) => {
  try {
    const response = await apiClient.post(`/projects/${projectId}/discovery-phase/technology-assessment`, assessmentData);
    return response.data;
  } catch (error) {
    console.error('Error saving technology assessment:', error);
    throw error;
  }
};

export const fetchTechnologyAssessmentFromSOW = async (projectId) => {
  try {
    const response = await apiClient.post(`/projects/${projectId}/discovery-phase/technology-assessment/fetch-from-sow`);
    return response.data;
  } catch (error) {
    console.error('Error fetching technology assessment from SOW:', error);
    throw error;
  }
};

// Feasibility Study
export const getFeasibilityStudy = async (projectId) => {
  try {
    const response = await apiClient.get(`/projects/${projectId}/discovery-phase/feasibility-study`);
    if (response.data && !response.data.message) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching feasibility study:', error);
    return null;
  }
};

export const saveFeasibilityStudy = async (projectId, studyData) => {
  try {
    const response = await apiClient.post(`/projects/${projectId}/discovery-phase/feasibility-study`, studyData);
    return response.data;
  } catch (error) {
    console.error('Error saving feasibility study:', error);
    throw error;
  }
};

export const fetchFeasibilityStudyFromSOW = async (projectId) => {
  try {
    const response = await apiClient.post(`/projects/${projectId}/discovery-phase/feasibility-study/fetch-from-sow`);
    return response.data;
  } catch (error) {
    console.error('Error fetching feasibility study from SOW:', error);
    throw error;
  }
};